// extracted by mini-css-extract-plugin
module.exports = {"ModelDetails":"styles_ModelDetails__mMzeb","fadeIn":"styles_fadeIn__1NB20","ModelBio":"styles_ModelBio__2lvU_"};